if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaLabelObserver = new MutationObserver(() => this.sanitizeMediaLabels());
      }

      hide() {
        this.mediaLabelObserver.disconnect();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.observeMediaLabels();
        this.sanitizeMediaLabels();
        this.showActiveMedia();
      }

      isInvalidMediaLabel(value) {
        const compact = String(value || '')
          .toLowerCase()
          .replace(/[\s\u200b-\u200d\ufeff|,/·:;._-]+/g, '');
        return compact.length > 0 && /^(?:(?:null|undefined))+$/.test(compact);
      }

      observeMediaLabels() {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        this.mediaLabelObserver.disconnect();
        this.mediaLabelObserver.observe(content, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['alt', 'title', 'aria-label', 'data-caption', 'data-title'],
        });
      }

      sanitizeMediaLabels() {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        const fallback = document.querySelector('.product__title h1')?.textContent?.trim() || 'Product image';
        const elements = [content, ...content.querySelectorAll('*')];

        elements.forEach((element) => {
          if (['SCRIPT', 'STYLE', 'TEMPLATE'].includes(element.tagName)) return;

          ['alt', 'title', 'aria-label', 'data-caption', 'data-title'].forEach((attribute) => {
            const value = element.getAttribute?.(attribute);
            if (!this.isInvalidMediaLabel(value)) return;
            if (attribute === 'alt') element.setAttribute(attribute, fallback);
            else element.removeAttribute(attribute);
          });

          [...element.childNodes].forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE && this.isInvalidMediaLabel(node.textContent)) node.remove();
          });

          if (!element.children.length && this.isInvalidMediaLabel(element.textContent)) element.remove();
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (activeMedia.tagName === 'IMG') { activeMedia.loading = 'eager'; activeMedia.fetchPriority = 'high'; }
        activeMedia.classList.add('active');
        // The selected image can be fetched after the initial modal is rendered.
        // Keep it first so legacy variant-media CSS cannot show the old image.
        activeMedia.parentElement.prepend(activeMedia);
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
